import TaskPanelContainer from '../TaskPanelContainer'
import EditTaskPanel from './EditTaskPanel'
import {PANEL_TYPES} from '../../constants'

export default class EditTaskPanelContainer extends TaskPanelContainer {
    constructor(parameters = {
        scheduleCalculator: null,
        onPanelHide: () => {},
        onTaskDeletedCb: () => {},
        onTaskMovedCb: () => {},
        datePickerMenu: null,
        needToHideOnOutsideClick: true,
        needShowMoire: false,
    }) {
        super({
            ...parameters,
            additionalClass: 'edit_task_sliding_panel sliding_panel',
            panelContent: new EditTaskPanel({
                showComments: true,
                showReportTab: true,
                showActions: true,
                dateFormat: Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M"),
                datePickerMenu: parameters.datePickerMenu,
                onTaskDeletedCb: parameters.onTaskDeletedCb,
                onTaskMovedCb: parameters.onTaskMovedCb,
            }),
            panelType: PANEL_TYPES.EDIT_TASK,
            onPanelHideCb: () => parameters.onPanelHide(this.state.openTaskId),
        })

        this.state = {
            ...super.state,
            openTaskId: null,
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/task/editPanel/EditTaskPanelContainer.js